import { render, staticRenderFns } from "./ApiTool.vue?vue&type=template&id=66480ae8&scoped=true&"
import script from "./ApiTool.vue?vue&type=script&lang=ts&"
export * from "./ApiTool.vue?vue&type=script&lang=ts&"
import style0 from "./ApiTool.vue?vue&type=style&index=0&id=66480ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66480ae8",
  null
  
)

export default component.exports